<template>
  <div class="interpretation-container">
    <div class="interpretation-section">
      <h3 class="section-title">ECOFF Interpretation</h3>
      <div v-if="!store.measuredCon">
        please enter a measured concentration !
      </div>
      <div v-else class="interpretation-content">
        <p class="interpret-item" v-html="compareToEcoff"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useTestStore } from "@/stores/testStore";

// Initialize the store
const store = useTestStore();

// Compute expected concentration
const expectedConcentration = computed(() => 
  parseFloat((store.measuredCon * store.predictedFup).toFixed(2))
);

// Compute comparison message to ECOFF
const compareToEcoff = computed(() => {
  if (store.predictedFup == null) {
    return null;
  }
  if (store.ecoff === 0 || store.ecoff === "ID") {
    return "No ECOFF data available.";
  } else if (expectedConcentration.value < store.ecoff * 4) {
    return `<strong>Theoretical free concentration</strong> (${expectedConcentration.value}mg/L) is <strong>lower</strong> than <strong>ECOFF</strong> * 4 (${store.ecoff * 4}mg/L) associated with the organism/antibiotic pair.`;
  } else {
    return `<strong>Theoretical free concentration</strong> (${expectedConcentration.value}mg/L) is <strong>higher</strong> than <strong>ECOFF</strong> * 4 (${store.ecoff * 4}mg/L) associated with the organism/antibiotic pair.`;
  }
});
</script>

<style scoped>
.interpretation-container {
  margin-top: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.interpretation-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
  min-width: 600px;
  box-sizing: border-box;
}

.section-title {
  color: #2c3e50;
  margin: 0 0 16px 0;
  font-size: 1.25rem;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
}

.interpretation-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.interpret-item {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  text-align: left;
}

.interpret-item strong {
  color: #2c3e50;
}

.status-success {
  color: #198754;
  display: block;
  padding: 8px;
  border-left: 4px solid #198754;
}

.status-warning {
  color: #ffc107;
  display: block;
  padding: 8px;
  border-left: 4px solid #ffc107;
}

.status-error {
  color: #dc3545;
  display: block;
  padding: 8px;
  border-left: 4px solid #dc3545;
}

.status-neutral {
  color: #6c757d;
  display: block;
  padding: 8px;
  border-left: 4px solid #6c757d;
}
</style>
